<template>
  <div>
    <div v-if="error" class="text-center pa-6">
      <div class="mb-3">Không xem trước được tệp này. Vui lòng tải xuống để xem.</div>
      <v-btn color="primary" outlined @click="$emit('download')">Tải xuống</v-btn>
    </div>
    <template v-else-if="doc">
      <PdfPage v-for="i in numPages" :key="i" :doc="doc" :page="i" />
    </template>
  </div>
</template>

<script>
import pdf from 'vue-pdf'
import PdfPage from './PdfPage.vue'

export default {
  components: { PdfPage },
  props: {
    url: { type: String, default: '' },
    openCount: { type: Number, default: 0 }
  },
  data() {
    return { doc: null, numPages: 0, error: false }
  },
  watch: {
    // Mỗi lần mở, openCount đổi -> reload (kể cả cùng file). KHÔNG remount -> tuần tự, tránh race condition trong queue của worker
    openCount: { immediate: true, handler: 'reload' }
  },
  methods: {
    async reload() {
      const token = this.openCount

      if (this.doc) {
        const oldDoc = this.doc
        this.doc = null
        this.numPages = 0
        await this.$nextTick()
        try {
          await oldDoc.destroy()
        } catch (e) {
        }
      }

      this.error = false
      const reqUrl = this.url
      if (!reqUrl) return
      if (this.openCount !== token) return 

      this.$loading.active = true
      try {
        const task = pdf.createLoadingTask(reqUrl)
        const doc = await task.promise
        if (this.openCount !== token) {
          doc.destroy() // stale -> dọn
          return
        }
        this.doc = doc
        this.numPages = doc.numPages
      } catch (e) {
        if (this.openCount !== token) return
        console.error('Xem PDF lỗi:', e)
        this.error = true
      } finally {
        if (this.openCount === token) this.$loading.active = false
      }
    }
  },
  destroyed() {
    if (this.doc) {
      this.doc.destroy()
      this.doc = null
    }
  }
}
</script>
